import {Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation} from '@angular/core';
import {Question} from '../../../models/question.model';
import {Answer} from '../../../models/answer.model';
import {AppComponent} from "../../../app.component";

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./checkbox.component.less']
})
export class CheckboxComponent implements OnInit {
  @Input() question!: Question;
  @Input() answers!: Answer[];
  @Input() disabled!: boolean;
  @Output() answerSelected = new EventEmitter<(number | null)[]>();
  selectedAnswers: (number | null)[] = [];
  global_texts: any = null;

  constructor(
    public app: AppComponent) {
  }

  ngOnInit(): void {
    this.app.sharedHelper.getGlobalTexts().subscribe((texts: any) => {
      this.global_texts = texts;
    });
  }

  onAnswerChange(): void {
    this.selectedAnswers = this.answers.filter((answer) => answer.selected).map((answer) => answer.id);
    console.log("this.selectedAnswers => ", this.selectedAnswers);
    this.answerSelected.emit(this.selectedAnswers);
  }
}
